import { useTranslation } from "react-i18next";
import type { OrderStatus } from "@/lib/api";
import { STATUS_STYLES } from "../format";

export default function StatusBadge({ status }: { status: OrderStatus }) {
  const { t } = useTranslation();
  const style = STATUS_STYLES[status] ?? STATUS_STYLES.pending_payment;
  return (
    <span
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium ${style.className}`}
    >
      <i className={style.icon}></i>
      {t(`orders.status.${status}`, { defaultValue: status })}
    </span>
  );
}
